import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "dialog"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.title)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "close" }, null, -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("img", {
            src: _imports_0,
            alt: "X",
            class: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          })
        ]),
        _createElementVNode("div", {
          class: "modal",
          innerHTML: _ctx.html
        }, null, 8, _hoisted_4)
      ]))
    : _createCommentVNode("", true)
}